// extracted by mini-css-extract-plugin
export var active = "CityesList-module--active--97e88";
export var address = "CityesList-module--address--7008a";
export var city = "CityesList-module--city--69e19";
export var fadeInAnimation = "CityesList-module--fadeInAnimation--3118d";
export var item = "CityesList-module--item--a53f1";
export var items = "CityesList-module--items--47137";
export var list = "CityesList-module--list--cb8d1";
export var phone = "CityesList-module--phone--c6346";
export var smallScreenItem = "CityesList-module--smallScreenItem--b115f";